import liveChatTab from '../../../../../../assets/svgs/liveChatTab.svg';
import pollTab from '../../../../../../assets/svgs/pollsTab.svg';
import commentaryTab from '../../../../../../assets/svgs/commentaryTab.svg';
import zoneTab from '../../../../../../assets/svgs/zoneTab.svg';
import rewardsTab from '../../../../../../assets/svgs/rewardsTab.svg';

export const tabs = ["Play by Play", "Live Chat", "Polls", "Zones"];
export const mobileTabs = [
    {
        tabName: "Commentary",
        tabValue: 2,
        tabIcon: commentaryTab
    },
    {
        tabName: "Live Chat",
        tabValue: 0,
        tabIcon: liveChatTab
    },
    {
        tabName: "Polls",
        tabValue: 1,
        tabIcon: pollTab
    },
    {
        tabName: "Zones",
        tabValue: 3,
        tabIcon: zoneTab
    },
    {
        tabName: "Rewards",
        tabValue: 4,
        tabIcon: rewardsTab
    }
];

export const ACCEPTED_IMAGE_MIME_TYPES = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif', 'image/webp']
export const ACCEPTED_VIDEO_MIME_TYPES = ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/webm']
export const ACCEPTED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp']
export const ACCEPTED_VIDEO_EXTENSIONS = ['mp4','mov','avi','webm']
export const MAX_IMAGE_SIZE_IN_MB = 10 
export const MAX_VIDEO_SIZE_IN_MB = 30 

export const PAGE_SIZE = 12;
export const ITEMS_PER_ROW = 4;

export const getFileType = (fileType) => {
    if ( fileType?.startsWith('image/')){
        return 'image';
    } else if ( fileType?.startsWith('video/')) {
        return 'video';
    } else {
        return 'unknown';
    }
}